import NoData from "assets/svgs/no_data/NoData";
import { isEmpty } from "lodash";
import { getValue, getLineItemsName } from "modules/utilities/utility";
import React, { useEffect, useMemo, useState } from "react";
import { OverlayTrigger, Placeholder } from "react-bootstrap";
import { Tooltip, Badge, Tag } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";

function OpenOrdersTable({ tableData, isLoading }) {
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);
  const [opa1, setOpa1] = useState("");
  const [count1, setCount1] = useState(0);
  const [sortData, setSortedData] = useState(tableData);

  useEffect(() => {
    setSortedData(tableData);
  }, [tableData]);

  const data = useMemo(() => {
    if (isEmpty(sortData)) return [];
    return sortData?.map((row) => ({
      key: getValue(row, "id"),
      case_id: getValue(row, "case_id"),
      openOrderName: getValue(row, "case.user.first_name"),
      ghostOrderName: getValue(row, "order_meta.customer.first_name"),
      phone_Number: getValue(row, "case.user.phone_number"),
      ghost_phone_Number: getValue(row, "order_phone_number"),
      orderDisplayId: getValue(row, "order_display_id"),
      orderName: getLineItemsName(row.order_meta?.line_items),
      orderStatus: getValue(row, "status"),
      orderSubStatus: getValue(row, "sub_status"),
      orderSource: getValue(row, "order_source"),
      orderDate: getValue(row, "created_at"),
      count: getValue(row, "count"),
      is_subscription: getValue(row, "is_subscription_order"),
      is_combo: getValue(row, "is_combo"),
      is_bulk_order: getValue(row, "is_bulk_order"),
      bulk_order_duration: getValue(row, "bulk_order_duration"),
      order_type: getValue(row, "order_type"),
      assignedTo: getValue(row, "assignment.first_name"),
      owner: getValue(row, "case.assignment.first_name"),
      warehouse: getValue(row, "order_warehouse.warehouses.name"),
      tracking_id: getValue(row, "tracking_id"),
      tracking_url: getValue(row, "tracking_url"),
      salesRep: getValue(row, "case.salesRep.first_name"),
      warehouse_assignment_time: getValue(row, "order_warehouse.created_at"),
      order_meta: getValue(row, "order_meta"),
    }));
  }, [sortData]);

  const handleSortDate = () => {
    if (!data) {
      return;
    }
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setSortedData([
        ...tableData?.sort(
          (a, b) => moment(a.created_at) - moment(b.created_at)
        ),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setSortedData([
        ...tableData?.sort(
          (a, b) => moment(b.created_at) - moment(a.created_at)
        ),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setSortedData([...tableData]);
    }
  };

  const handleSortStatus = () => {
    if (!data) {
      return;
    }

    if (count1 === 0) {
      setOpa1("dsc");
      setCount1(1);
      setSortedData([
        ...tableData?.sort((a, b) => a.status.localeCompare(b.status)),
      ]);
    } else if (count1 === 1) {
      setOpa1("asc");
      setCount1(2);
      setSortedData([
        ...tableData?.sort((a, b) => b.status.localeCompare(a.status)),
      ]);
    } else if (count1 === 2) {
      setOpa1("");
      setCount1(0);
      setSortedData([...tableData]);
    }
  };
  const renderOrderData = (record) => {
    if (record.orderStatus !== "ghost") {
      let subscriptionPlatform = "";
      if (record.is_subscription) {
        subscriptionPlatform = getSubscriptionPlatform(record.order_meta);
        subscriptionPlatform = subscriptionPlatform
          ? `(${subscriptionPlatform})`
          : "";
      }

      return (
        <div className="d-flex flex-column">
          <Link className="link" to={`/lead-details/${record.case_id}`}>
            <div className="text-break text-wrap text-primary fw-bold"> {record.openOrderName}</div>
          </Link>

          <p className="text-secondary text-wrap text-break">
            {isEmpty(record.phone_Number)
              ? record.ghost_phone_Number
              : record.phone_Number}
          </p>

          <div>
            {record.is_subscription && (
              <Tooltip
                placement="bottom"
                title={`Subscription Order ${subscriptionPlatform}`}
              >
                <span className="badge bg-success me-1">S</span>
              </Tooltip>
            )}

            {record.is_bulk_order && (
              <Tooltip
                placement="bottom"
                title={`Bulk Order (${record.bulk_order_duration} months)`}
              >
                <span className="badge bg-success me-1">B</span>
              </Tooltip>
            )}
            {record.is_combo && (
              <Tooltip placement="bottom" title={`Combo Order`}>
                <span className="badge bg-success me-1">C</span>
              </Tooltip>
            )}
          </div>
        </div>
      );
    } else {
      return <span>{record.ghostOrderName}</span>;
    }
  };

  return (
    <div>
      <div className="mt-1 shadow rounded">
        <div className="d-flex gap-1  border table-head rounded-top">
          <span className="flex-1 py-3 ps-1  border-end fw-bold text-black">
            Name
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Order Id
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Order Name
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            New/Repeat
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Order SOurce
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Order Sub Status
          </span>
          <Tooltip
            placement="top"
            title={
              opa1 == "asc" ? (
                <span>Click to cancel sort</span>
              ) : opa1 == "dsc" ? (
                <span>Click to sort Descending</span>
              ) : (
                <span>Click to sort Ascending</span>
              )
            }
          >
            <span
              className="flex-1 py-2  border-end fw-bold text-black cursor-pointer"
              onClick={handleSortStatus}
            >
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                <span className="fw-bold text-black">Order Status</span>
              </span>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "0.3rem",
                }}
              >
                <div
                  className={
                    opa1 === ""
                      ? "opacity-100"
                      : opa1 === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa1 === ""
                      ? "opacity-100 mt-n2"
                      : opa1 === "dsc"
                      ? "opacity-50 mt-n2"
                      : "opacity-100 mt-n2"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </span>
          </Tooltip>
          <Tooltip
            placement="top"
            title={
              opa == "asc" ? (
                <span>Click to cancel sort</span>
              ) : opa == "dsc" ? (
                <span>Click to sort Descending</span>
              ) : (
                <span>Click to sort Ascending</span>
              )
            }
          >
            <span
              className="flex-1 py-2  border-end fw-bold text-black cursor-pointer"
              onClick={handleSortDate}
            >
              <span
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                <span className="fw-bold text-black">Order Date</span>
              </span>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "1rem",
                }}
              >
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa === ""
                      ? "opacity-100 mt-n2"
                      : opa === "dsc"
                      ? "opacity-50 mt-n2"
                      : "opacity-100 mt-n2"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </span>
          </Tooltip>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Assigned To
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Owner
          </span>
          <span className="flex-1 py-3  border-end fw-bold text-black">
            Sales Rep
          </span>
        </div>
        {isLoading ? (
          <div>
            {Array.from({ length: 10 }).map((_, index) => (
              <Placeholder
                key={index}
                as="p"
                size="lg"
                animation="glow"
                className={`p-3 border border-top-0 mb-0`}
              >
                <Placeholder xs={12} />
              </Placeholder>
            ))}
          </div>
        ) : data?.length !== 0 && isLoading == false ? (
          data?.map((item, index) => {
            return (
              <div
                className={`d-flex gap-1 table-row border border-top-0 ${
                  index === 9 && "rounded-bottom"
                }`}
              >
                <span className="flex-1 ps-1 text-black border-end">
                  {renderOrderData(item)}
                </span>
                <span className="flex-1 border-end pt-1 ">
                  <div className="text-black">{item?.orderDisplayId}</div>
                  <Tag className="uppercase" color="green">
                    <div className="text-wrap text-break">
                      {" "}
                      {item?.order_type?.replaceAll("_", " ")}
                    </div>
                  </Tag>
                </span>
                <Tooltip placement="top" title={item?.orderName}>
                  <span className="flex-1 text-black border-end cursor-pointer text-truncate pt-2">
                    {item?.orderName}
                  </span>
                </Tooltip>
                <span className="flex-1 text-black border-end pt-2">
                  {item?.count <= 1 ? (
                    <Tag color="gold" key={index}>
                      NEW
                    </Tag>
                  ) : (
                    <Tag color="green" key={index}>
                      <div className="text-break text-wrap">
                        REPEAT ORDER {item?.count}
                      </div>
                    </Tag>
                  )}
                </span>
                <span className="flex-1 text-black border-end pt-2">
                  {
                    <Tag key={item?.orderSource} color="gold">
                      {item?.orderSource
                        ? item?.orderSource.toUpperCase()
                        : "NONE"}
                    </Tag>
                  }
                </span>
                <span className="flex-1 text-black border-end pt-2">
                  {
                    <Tag key={item?.subStatus} color="geekblue">
                      {item?.subStatus ? item?.subStatus.toUpperCase() : "NONE"}
                    </Tag>
                  }
                </span>
                <span className="flex-1 text-black border-end pt-2">
                  {
                    <Tag key={item?.orderStatus} color="geekblue">
                      <div className="text-break text-wrap">
                        {item?.orderStatus && item?.orderStatus.toUpperCase()}
                      </div>
                    </Tag>
                  }
                </span>
                <span className="flex-1 text-black border-end pt-2">
                  {moment(item?.orderDate).format("DD MMM YYYY, h:mm a")}
                </span>
                <span className="flex-1 text-black txt-wrap text-break border-end pt-2">
                  {item?.assignedTo}
                </span>
                <span className="flex-1 text-black text-wrap text-break border-end pt-2">
                  {item?.owner}
                </span>
                <span className="flex-1 text-black text-wrap text-break border-end pt-2">
                  {item?.salesRep}
                </span>
              </div>
            );
          })
        ) : (
          <div className="w-100 d-flex justify-content-center border bg-white">
            <h3 className="p-3 ">Data is not Available</h3>
            <span>
              <NoData />
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default OpenOrdersTable;
